import { render } from "./AuditEntryUpdates.vue?vue&type=template&id=0d63967a"
import script from "./AuditEntryUpdates.vue?vue&type=script&lang=js"
export * from "./AuditEntryUpdates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__